import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { FormBuilder, Validators } from '@angular/forms';
import { NodesService } from '../services/nodes.service';
import * as moment from "moment";
@Component({
  selector: 'dialog-add-version',
  templateUrl: './dialog-add-version.component.html',
  styleUrls: ['./dialog-add-version.component.scss']
})
export class DialogAddVersionComponent implements OnInit {
  loading = false;
  myfilename: any;
  newNode: any;
  newBlob: any;
  b64Blob: any;
  isMajor = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogAddVersionComponent>,
    private dialog: MatDialog, public fb: FormBuilder, private nodeService: NodesService) {
  }

  ngOnInit(): void {
  }

  versionForm = this.fb.group({
    version: ['minor', [Validators.required]],
    document: ['', Validators.required],
    file: ['', Validators.required],
    comment: '',
    fileUpload: ''
  })

  fileChangeEvent(event, index) {
    if (event.target.value) {
      const file = event.target.files[0];

      this.newNode = file;
    }
  }

  changeFile(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  onSubmit() {
    const form = new FormData();
    form.append('filedata', this.newNode, this.newNode.name);
    if (this.versionForm.get('version').value == 'major') {
      this.isMajor = true;
    }
    this.nodeService.uploadNewVersion({
      fileToSend: this.newNode,
      destinationId: this.data.file.id,
      newblob: this.newBlob,
      isMajor: this.isMajor,
      comment: this.versionForm.get('comment').value,
      id: this.data.file.id
    })
      .then(async (res) => {

        this.dialogRef.close({ success: true });
      })
      .catch((err) => {
      });
  }
}
